import * as React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import './i18n';
import App from './app';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/configureStore';
import theme, { ThemeProvider } from 'shamrock-clover-ui/dist/clover/Theme/Theme';
import FirebaseAnalytics from './components/core/analytics';
import { Auth0Provider } from '@auth0/auth0-react';
import V2LogoutLanding from './entry-points/logout/V2LogoutLanding';
const ShamrockCoreConfig = require('ShamrockCoreConfig');

const Config = require('Config');

require('stream');
require('./assets/images/favicon.ico');
require('./assets/images/rts-blue.svg');

FirebaseAnalytics.init(ShamrockCoreConfig.firebaseConfig);

// This is a temporary measure only until OOIDA is able to update their links.
function handleIfShouldRedirectToOOIDARegistration() {
  if (window.location.hash === '#/register/ooida') {
    window.location = Config.ooidaRegistration;
    return true;
  }
  return false;
}

function bootstrap() {
  const container = document.getElementById('app');
  const root = createRoot(container); // createRoot(container!) if you use TypeScript
  root.render(
    <Auth0Provider
      domain={Config.auth0CustomDomain}
      clientId={Config.auth0ClientId}
      skipRedirectCallback={window.location.pathname === '/loads/company/quickbooks'}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `https://${Config.auth0Domain}/api/v2/`,
        scope: 'openid profile email offline_access',
      }}
    >
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route path="/v2/logout/" key={'v2/logout'} element={<V2LogoutLanding />} />
              <Route path="/*" key={'app'} element={<App />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </Auth0Provider>,
  );
}

function main() {
  if (!handleIfShouldRedirectToOOIDARegistration()) {
    bootstrap();
  }
}
main();

// Redux App Types:
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
